export default {
    message: {
        tiers: {
            t1: {
                label: "Independiente",
                desc: "<p>Acceso unificado a todas las aplicaciones virtuales, web y SaaS. Protege a los usuarios, las aplicaciones y los datos con controles de seguridad contextuales de extremo a extremo.</p><p>Proporciona un proxy sin VPN y SSO a las aplicaciones web, SaaS, virtuales y móviles, así como protección contra el contenido malicioso, registradores de pulsaciones de teclas y malware de captura de pantallas.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Solución de espacio de trabajo completa para los trabajadores que necesitan un espacio de trabajo digital completo con seguridad granular, pero que no requieren aplicaciones ni escritorios virtuales.</p><p>Incluye la funcionalidad Workspace Standard, más controles de seguridad avanzados para SaaS y web, gestión de terminales unificada y Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solución de espacio de trabajo completa que incluye opciones de implementación híbrida para Citrix Virtual Apps and Desktops.</p><p>Incluye la funcionalidad Workspace Premium más una opción de administración cloud para Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}